import Cookies from 'universal-cookie';
import $ from 'jquery';
import { useLocation } from 'react-router-dom';

var checkPermission = false;
var checkSchool = false;

export default function MenuTreeView() {
  const cookies = new Cookies();
  var userStore = cookies.get('user_store');
  const location = useLocation();
  if (userStore != undefined && userStore.roles != undefined) {
    if (userStore.roles.school != undefined && userStore.roles.school == true) {
      checkSchool = true;
    }
  }

  var arrLink = [
    '/',
    '/home',
    '/trang-chu',
    '/huong-dan',
    '/account',
    '/khoi',
    '/khoi-tao-phong-thi',
    '/step-them-hoc-sinh',
    '/step-them-hoc-sinh-phong',
    '/step-upload-de-thi',
    '/step-upload-de-thi-thptqg',
    '/step-chuyen-de',
    '/lop',
    '/xu-ly-tinh-huong-thi',
    '/quan-ly-diem',
    '/diem-danh-sach',
    '/chi-tiet-diem',
    '/de-thi-can-lam',
    '/de-thi',
    '/danh-sach-cau-hoi',
    '/cap-nhat-cau-hoi',
    '/cap-nhat-cau-hoi-thptqg',
    '/chi-tiet-lop',
    '/quan-ly-ky-thi',
    '/quan-ly-mon-hoc',
    '/chi-tiet-bai-thi',
    '/chi-tiet-bai-thi-thptqg',
    '/hanh-trinh-lam-bai',
    '/thi-thu',
    '/thi-thu-thpt-qg',
    '/cham-diem-bai-thi',
    '/danh-sach-bai-thi-tu-luan',
    '/danh-sach-bai-thi-tu-luan-lop',
    '/danh-sach-chua-cham-diem',
    '/danh-sach-chua-cham-diem-lop',
    '/danh-sach-da-cham-diem',
    '/danh-sach-da-cham-diem-lop',
    '/danh-sach-de-thi-tu-luan',
    '/testing',
    '/danh-sach-giao-vien',
    '/in-bai-thi',
    '/de-thi-da-chuyen',
    '/danh-sach-giao-vien-quan-ly-lop',
    //hs
    '/phong-thi-truc-tuyen',
    '/lich-su-thi',
    '/thi',
    '/thi-thpt-2025',
    '/xem-ket-qua',
    '/xem-ket-qua-2025',
    '/thong-tin-tai-khoan',
    '/tao-de-thi-tu-ngan-hang',
    '/tai-lieu-huong-dan',
    '/xu-ly-phieu-tra-loi',
    '/quan-ly-phieu-tra-loi'
  ];
  console.log(location.pathname);
  arrLink.forEach((value) => {
    if (value === location.pathname) {
      checkPermission = true;
    }
    if (location.pathname.startsWith('/xu-ly-phieu-tra-loi/')) {
      checkPermission = true;
    }
  });
  if (!checkPermission) {
    window.location.href = '/not-found';
  }

  function hideMenu() {
    $('body').toggleClass('menu-active');
  }

  return (
    <div className="sidebar" id="menuteacher">
      <div className="navbar-brand-box">
        {
          <a href="javascript:void(0)" className="logo" title="">
            <img
              src={
                process.env.REACT_APP_STATIC_URL +
                'content/assets/images/logo_hst_chu_den.png'
              }
              alt="logo"
              style={{ height: '72px' }}
              className="logo-full"
            />
            <img
              src={
                process.env.REACT_APP_STATIC_URL +
                'content/assets/images/icon-user.png'
              }
              alt=""
              style={{ height: '35px' }}
              className="logo-mini"
            />
          </a>
        }
        <a
          href="#"
          className="nav-link menu-toggle"
          onClick={(e) => hideMenu()}>
          {' '}
          {/* onclick thường */}
          <span className="icon-menu" />
        </a>
      </div>
      <div className="sidebar-menu-scroll">
        <ul className="sidebar-menu ">
          <li className="sidebar-item sidebar-link has-sub" id="quanly">
            <a href="javascript:void(0)">
              <span className="icon-businessman" />
              <span>Quản lý</span>
            </a>
            <ul className="sidebar-sub" id="subquanly">
              {/* {
                          <li className="sidebar-item sidebar-link" id="quanlymonhoc">
                            <a href="/quan-ly-mon-hoc">Quản lý môn học</a> 
                          </li>
                      } */}
              <li className="sidebar-item sidebar-link" id="danhsachgiaovien">
                <a href="/danh-sach-giao-vien">Danh sách giáo viên</a>
              </li>
              <li className="sidebar-item sidebar-link" id="danhsachhocsinh">
                <a href="/khoi">Danh sách học sinh</a>
              </li>

              <li className="sidebar-item sidebar-link" id="quanlykythi">
                <a href="/quan-ly-ky-thi">Quản lý kỳ thi</a>
              </li>

              <li className="sidebar-item sidebar-link" id="quanlydiem">
                <a href="/quan-ly-diem">Quản lý điểm</a>
              </li>

              <li
                className="sidebar-item sidebar-link"
                id="danhsachhocsinhphong">
                <a href="/step-them-hoc-sinh-phong">DS học sinh trong phòng</a>
              </li>

              <li
                className="sidebar-item sidebar-link"
                id="danhsachgiaovienquanlylop">
                <a href="/danh-sach-giao-vien-quan-ly-lop">
                  DS giáo viên quản lý lớp
                </a>
              </li>
            </ul>
          </li>
          <li
            className="sidebar-item sidebar-link has-sub"
            id="quanlythituluan">
            <a href="javascript:void(0)">
              <span className="icon-businessman" />
              <span>Quản lý thi tự luận</span>
            </a>
            <ul className="sidebar-sub" id="subquanlythituluan">
              <li
                className="sidebar-item sidebar-link"
                id="danhsachbaithituluan">
                <a href="/danh-sach-bai-thi-tu-luan">
                  Danh sách bài thi tự luận
                </a>
              </li>
            </ul>
          </li>
          <li
            className="sidebar-item sidebar-link"
            id="tochucthitructuyen"
            style={checkSchool == true ? { display: '' } : { display: 'none' }}>
            <a href="/khoi-tao-phong-thi">
              <span className="icon-video-conference" />
              <span>Tổ chức thi trực tuyến</span>{' '}
            </a>
          </li>
          <li className="sidebar-item sidebar-link" id="xulytinhhuongthi">
            <a href="/xu-ly-tinh-huong-thi">
              <span className="icon-presentation" />
              <span>Xử lý tình huống thi</span>{' '}
            </a>
          </li>
          <li className="sidebar-item sidebar-link has-sub" id="quanlydethi">
            <a href="javascript:void(0)">
              <span className="icon-book" />
              <span>Quản lý đề thi</span>
            </a>
            <ul className="sidebar-sub" id="subquanlydethi">
              <li className="sidebar-item sidebar-link" id="danhsachdethi">
                <a href="/de-thi">Danh sách đề thi</a>
              </li>
              <li
                className="sidebar-item sidebar-link"
                id="danhsachdethidachuyen">
                <a href="/de-thi-da-chuyen">Danh sách đề thi đã chuyển</a>
              </li>
              <li className="sidebar-item sidebar-link" id="uploaddethi">
                <a href="/step-upload-de-thi?id=0&type=1">Upload đề thi</a>
              </li>
            </ul>
          </li>
          <li
            className="sidebar-item sidebar-link has-sub"
            id="quanlyphieutraloi">
            <a href="javascript:void(0)">
              <span className="icon-book" />
              <span>Chấm bài giấy</span>
            </a>
            <ul className="sidebar-sub" id="subquanlyphieutraloi">
              <li className="sidebar-item sidebar-link" id="xulyphieutraloi">
                <a href="/xu-ly-phieu-tra-loi">Quản lý đợt chấm</a>
              </li>
              {/* <li
                className="sidebar-item sidebar-link"
                id="quanlyphieutraloilist">
                <a href="/quan-ly-phieu-tra-loi">Quản lý phiếu trả lời</a>
              </li> */}
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}
